import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import { Sidebar } from "primereact/sidebar";

import { Button, CheckboxField } from "../../helpers";
import { Table } from "../../helpers"
import Menu from "../../helpers/Menu";

import RaiseTicketModal from "./Components/RaiseTicketModal";
import Search from "./Components/Search";
import UpdateVPAdjustmentModal from "./Components/UpdateVPAdjustmentModal";

import Loading from "../../common/Loading";
import PMCompanyName from "../../common/PMCompanyName";
import PMUserName from "../../common/PMUserName";
import Description from "../../common/Description";
import ButtonGroup from "../../common/ButtonGroup";
import CopyToClipboard from "../../common/CopyToClipboard";
import FileViewModal from "../../common/FileViewModal";

import { updateAdjustmentNoteBookingStatus } from "../../services/api/adjustmentNotes";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchSellerDebitNotes, setIsSearchVisible } from "../../services/redux/reducers/sellerDebitNote/sellerDebitNote";
import { getDateString, getCompanyShortName, getFullName, isMobile, checkPermissions } from "../../utils";
import { useSearchPin } from "../../hooks/useSearchPin";

import RaiseImg from "../../images/click.jpg"
import greyClockImg from "../../images/greyClock.png"
import checkInCircleImg from "../../images/check-circle.png"
import WorkInProgressImg from "../../images/work-in-progress.png";
import { DATE_FORMAT } from "../../constants";


const SellerDebitNoteBooking = () =>{
    const dispatch = useDispatch()
    const { isSearchPinned, toggleSearchPin, setSearchPin } = useSearchPin()
    
    const [selectedAdjustmentNotes, setSelectedAdjustmentNotes] = useState([])
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [isRaiseTicketVisible, setIsRaiseTicketVisible] = useState(false)
    const [selectedRow, setSelectedRow] = useState({})
    const [visibleDocument, setVisibleDocument] = useState(false)
    const [selectedAdjNoteDoc, setSelectedAdjNoteDoc] = useState('')
    const [isUpdateVPAdjustmentVisible, setIsUpdateVPAdjustmentVisible] = useState(false)
    const [selectedVPAdjustmentRow, setSelectedVPAdjustmentRow] = useState({})
    const [isHoveringSearchZone, setIsHoveringSearchZone] = useState(false)
    const [hasEverHoveredRightEdge, setHasEverHoveredRightEdge] = useState(false)

    const usersData = useSelector(state => state.userDetails)
    const isLoading = useSelector(state => state.sellerDebitNotes.loading)
    const searchParams = useSelector(state => state.sellerDebitNotes.searchParams)
    const paginationParams = useSelector(state => state.sellerDebitNotes.paginationParams)
    const adjustmentNotesData = useSelector(state => state.sellerDebitNotes.sellerDebitNotesData)
    const isSearchVisible = useSelector(state => state.sellerDebitNotes.isSearchVisible)
    const isSearchActive = useSelector(state => state.sellerDebitNotes.isSearchActive)

    const actionMenu = useRef(null)
   
    const isMobileDevice = isMobile()

    useEffect(() => {
        if (!isSearchPinned && !isHoveringSearchZone) {
            dispatch(setIsSearchVisible(false))
          }

        const handleMouseMove = (e) => {
            if (isSearchPinned) return

            const panelWidth = window.innerWidth * 0.18
            const buffer = 8
            const screenRightEdge = window.innerWidth
            const activeZoneLeft = screenRightEdge - (panelWidth + buffer)

            if (e.clientX < activeZoneLeft) {
                setIsHoveringSearchZone(false)
                setHasEverHoveredRightEdge(false)
            } else {
                setIsHoveringSearchZone(true)
            }
        }

        if (!isSearchPinned && (isHoveringSearchZone || hasEverHoveredRightEdge)) {
            window.addEventListener('mousemove', handleMouseMove)
        }

        return () => {
            window.removeEventListener('mousemove', handleMouseMove)
        }
    }, [isSearchPinned, isHoveringSearchZone, hasEverHoveredRightEdge])

    const getCompanyBody = (row)=>{
        let companyShortName = getCompanyShortName(row["companyName"])

        return <PMCompanyName companyName={companyShortName} companyId={row.companyId}/>
    }

    const getKAMBody = (row)=>{
        let kamName = row["userFirstName"] 

        if(row["userLastName"]){
            kamName = kamName + " " + row["userLastName"]
        }
        return <PMUserName userName={kamName} userId={row.createdBy}/>
    }

    const getSellerPOBody = (row)=>{        
        let dateString = getDateString(row["sellerPOCreatedDate"])
        return (
            <div className="text-center">
                <div className='flex flex-row justify-content-center' >
                    <p className='doc-no' style={{cursor : "pointer"}} onClick={() => window.open(`/sellerpo/${row["sellerPOId"]}`, '_blank')}>{row["sellerPODocNo"]}</p>
                    <CopyToClipboard text={row["sellerPODocNo"]} />
                </div>
                <div className="date-string">{dateString}</div>
            </div>
        )
    }

    const getSellerDebitNoteDocBody = (row) => {
        return (
            <div className="text-center">
                <div className='flex flex-row justify-content-center' >
                    <p className='doc-no' style={{cursor : "pointer"}} onClick={() => window.open(`/debitnote/${row?.adjustmentNoteId}`, '_blank')}>{row?.docNo ? row?.docNo : "NA"}</p>
                    <CopyToClipboard text={row?.docNo} />
                </div>
                <div>{getDebitNoteDate(row)}</div>
            </div>
        )
    }

    const getCreditNoteNoBody = (row) => {
        return (
            row.docProofNo ?
            <div className="flex justify-content-center align-items-center" style={{fontWeight: "bold", fontSize: "13px"}}>
                <span style={{fontSize: "12px", wordBreak: "keep-all"}}>{row.docProofNo}</span><i className="pi pi-eye cursor-pointer ml-1 compare-tooltip" onClick={() => {setVisibleDocument(true); setSelectedAdjNoteDoc(row.docProof)}}/>
            </div>
            :
            "-"
        )
    }

    const getLinkedCreditNoteDocNoBody = (row) => {
        return (
            row.linkedDocNo ?
            <div className="text-center">
                <div className='flex flex-row justify-content-center' >
                    <p className='doc-no' style={{cursor : "pointer"}} onClick={() => window.open(`/docs/${row.linkedDocNo}`, '_blank')}>{row.linkedDocNo}</p>
                    <CopyToClipboard text={row.linkedDocNo} />
                </div>
            </div>
            :
            "-"
        )
    }

    const getDebitNoteDate = (row) => {
        let dateString = getDateString(row?.createdAt)

        return (
            <div className="text-center">
                <div>{dateString}</div>
            </div>
        )
    }

    const getSellerPIDateBody = (row)=>{
        let dateString = getDateString(row["sellerPIDate"])
        return(
            <div className="">
                <div>{dateString}</div>
            </div> 
        )
    }

    const getSellerPIUploadedDateBody = (row)=>{
        let dateString = getDateString(row["sellerPIUploadedDate"])
        return(
            <div className="">
                <div>{dateString}</div>
            </div> 
        )
    }

    const getHeaderCheckbox = ()=>{
        return(
            <div className=""> <CheckboxField onChange={(e) => handleSelectClick(e)}  checked={adjustmentNotesData?.length && adjustmentNotesData?.length === selectedAdjustmentNotes?.length}/></div>
        )
    }

    const getBodyCheckbox = (row)=>{
        const relatedAdjustmentNote = selectedAdjustmentNotes?.find(eachAdjustmentNote => eachAdjustmentNote?.adjustmentNoteId === row?.adjustmentNoteId)
        return(
            <CheckboxField onChange={() => handleCheckboxClick(row)} checked={relatedAdjustmentNote ? true : false}/>
        )
    }

    const getBookedStatusBody = (row) => {
        let bookingDate = ""
        if(row["bookingLogBookedAt"]){
            bookingDate = moment(row["bookingLogBookedAt"]).format(DATE_FORMAT)
        }

        return(
            <div className='req-no-container ml-1' style={{position: "relative"}}>
                <div className='flex flex-row justify-content-center align-items-center'>
                    {
                        row["bookedStatus"] ? 
                        <>
                            <div className='doc-no'>Booked</div>
                        </>
                        : <div className='doc-no'>Unbooked</div>
                    }
                </div>
                { row["bookedStatus"] ? <p className='date'>{bookingDate}</p> : "" }
            </div>
        )
    }

    const getBookedByBody = (row)=>{
        let bookedByUserName = getFullName(row["bookedUserFirstName"], row["bookedUserLastName"])
        return (
            <div className="text-center">
                {
                    row["bookedStatus"] && row["bookedBy"] ?
                    (
                        <div className="text-center">
                            <div>{bookedByUserName}</div>
                        </div> 
                    ): "-"
                }
            </div>    
        )
    }

    const getPurchaseInvoiceBody = (row)=>{
        return(
            <div className="">
                <div className="font-semibold">PI No: {row["sellerPINumber"]}</div>
                <div>{getSellerPIDateBody(row)}</div>
            </div> 
        )
    }

    const getCreditNoteDocBody = (row) => {

        const handleView = () => {
            setVisibleDocument(true)
            setSelectedAdjNoteDoc(row.docProof)
        }

        return (
            <>
                {
                    !row?.docProof ? <p>-</p> : <Button label="View" text className="small-btn" onClick={handleView}/> 
                }
            </>
        )
    }

    const getCNUploadedDateBody = (row)=>{
        if(row?.docProofUploadedDate){
            let dateString = getDateString(row["docProofUploadedDate"])
            return (
                <div className="">
                    <div>{dateString}</div>
                </div>
            )
        }

        return "-"
    }

    const branchBody =(row)=>{
        if(row.pmBranchId){
            const companyBranches = usersData.PMCompanyDetails.companyBranches
            const relatedBranch = companyBranches.find(each => each.branchId === row.pmBranchId)

            return (
                <div className="">
                    <div>{relatedBranch.branchName}</div>
                </div>
            )
        }
        return "-"
    }

    const getAmountBody =(row)=>{
        if(row.totalAmountWithTax){
            return (
                <div className="">
                    <div>{row.totalAmountWithTax}</div>
                </div>
            )
        }
        return "-"
    }

    const getVPAdjustmentBody = (row) => {
        console.log("row", row)
        const {isPermitted} = checkPermissions({ ...usersData, permissions: [106] })
        
        if (!isPermitted) {
            return (
                <div className="text-center">
                    <span className="text-gray-500">No Access</span>
                </div>
            )
        }

        const currentAdjusted = row.vpAdjustedAmount || 0;
        const totalAmount = row.totalAmountWithTax || 0;
        const remainingAmount = Math.max(0, totalAmount - currentAdjusted);
        const isFullyAdjusted = row.isVPFullyAdjusted || currentAdjusted >= totalAmount;

        return (
            <div className={`text-center ${row.vpAdjustmentRemarks ? "custom-vp-remarks-tooltip-" + row.adjustmentNoteId : ""}`}> 
                {row.vpAdjustmentRemarks ?
                    <Tooltip target={`.custom-vp-remarks-tooltip-${row.adjustmentNoteId}`} position="top" autoHide>
                        <div className="text-left">{row.vpAdjustmentRemarks}</div>
                    </Tooltip> 
                    :
                    null
                }
                <div className="">
                    <small className="text-gray-600">
                        Adjusted: Rs {currentAdjusted}
                    </small>
                </div>
                <div className="">
                    <small className="text-gray-600">
                        Remaining: Rs {remainingAmount}
                    </small>
                </div>
                { !isFullyAdjusted ?
                    <Button 
                        label={"Adjust"} 
                        className="small-btn" 
                        onClick={() => handleUpdateVPAdjustment(row)}
                        disabled={isFullyAdjusted}
                    />
                    :
                    null
                }
            </div>
        )
    }

    const getRemarksBody = (row) => {
        let updatedRemarks = ""

        let adjustmentNoteReasonRemarks = 'Reason: '
            
        if (row.adjustmentTypeId === 3){
            adjustmentNoteReasonRemarks += "Rejected / Short"
        }else if (row.adjustmentTypeId === 9){
            adjustmentNoteReasonRemarks += "From Buyer CN (Return To Seller)"
        }else if (row.adjustmentTypeId === 10){
            adjustmentNoteReasonRemarks += "From Smart Stock"
        }

        updatedRemarks = `${adjustmentNoteReasonRemarks} \n` + updatedRemarks 

        return (
            <>
                {updatedRemarks ? <div className="text-left" style={{fontWeight: '600', fontSize: '14px'}}>{updatedRemarks}</div> : ""}
                {row.remarks ?  <Description text={row.remarks} maxLength={100} /> : ""}
            </>
        )
    }
    
    const handleRaiseTicket = (row) => {
        setSelectedRow(row)
        setIsRaiseTicketVisible(true)
    }

    const handleUpdateVPAdjustment = (row) => {
        setSelectedVPAdjustmentRow(row)
        setIsUpdateVPAdjustmentVisible(true)
    }

    const raiseIssueBody = (row) => {
        const {isPermitted} = checkPermissions({ ...usersData, permissions: [169] })

        if (!row["relatedTicket.ticketId"]) {
            return (
                <>
                    <i style={{ cursor: isPermitted ? "pointer" : "not-allowed", fontSize: "20px", color: "red" }}
                        className={`${!isPermitted ? 'disabled-icon' : 'cursor-pointer'} custom-raise-tooltip`}
                        onClick={isPermitted ? () => handleRaiseTicket(row) : null}
                    >
                        <img src={RaiseImg} style={{ height: 26 }} />
                    </i>
                    {
                        !isPermitted && (
                            <Tooltip target={`.custom-raise-tooltip`} position="top" autoHide>
                                Access restricted: Only Finance team can raise issues.
                            </Tooltip>
                        )
                    }
                </>
            )
        }

        return (
            <div>
                {([1,9,10].includes(row["relatedTicket.ticketStatusId"])) ? 
                    (
                        <a style={{ cursor: "pointer", fontSize: "20px", color: "grey" }} onClick={() => window.open(`/tickets/edit/${row["relatedTicket.ticketId"]}`, '_blank')} title={'In Progress'}>
                            <img src={WorkInProgressImg} style={{ height: 23 }} />
                        </a>
                    )
                    :
                    row["relatedTicket.ticketStatusId"] === 8 ? (
                        <a
                            style={{ cursor: "pointer", fontSize: "20px", color: "orange" }}
                            onClick={() => window.open(`/tickets/edit/${row["relatedTicket.ticketId"]}`, '_blank')}
                            title={'Pending Closure'}
                        > <img src={greyClockImg} style={{ height: 24 }} /></a>
                    ) : (
                        <a style={{ cursor: "pointer", fontSize: "20px", color: "darkgreen" }} onClick={() => window.open(`/tickets/edit/${row["relatedTicket.ticketId"]}`, '_blank')} title={'Resolved'}>
                            <img src={checkInCircleImg} style={{ height: 30 }} />
                        </a>
                    )
                }
            </div>
        )
    }

    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
    }

    const tableColumns = [
        {
            header: getHeaderCheckbox, 
            body: (row) => getBodyCheckbox(row)
        },
        {
            header: 'Company Name',
            field: '',
            body : getCompanyBody,
            style: { minWidth: "180px"}
        },
        {
            header: 'Seller PO No',
            field: '',
            body : getSellerPOBody,
            style: { minWidth: "150px" }
        },
        {
            header : 'KAM',
            field : '',
            body : getKAMBody,
            style: { minWidth: "130px" }
        },
        {
            header: 'Debit Note No/ Date',
            field: 'docNo',
            body: getSellerDebitNoteDocBody,
            style: { minWidth: "120px" }
        },
        // {
        //     header: 'Debit Note Date',
        //     field: 'debitNoteDate',
        //     body: getDebitNoteDate,
        //     style: { minWidth: "90px"}
        // },
        {
            header: 'Credit Note No',
            body: getCreditNoteNoBody,
            style: { minWidth: "130px" }
        },
        // {
        //     header: 'Credit Note',
        //     field: '',
        //     body: getCreditNoteDocBody,
        //     style: { minWidth: "90px"}
        // },
        {
            header: 'Buyer Credit Note No.',
            body: getLinkedCreditNoteDocNoBody,
            style: { minWidth: "130px" }
        },
        {
            header: 'CN Uploaded Date',
            field: '',
            body: getCNUploadedDateBody,
            style: { minWidth: "90px"}
        },
        {
            header: 'Purchase Invoice/Date',
            field: '',
            body : getPurchaseInvoiceBody,
            style: { minWidth: "150px"}
        },
        // {
        //     header: 'PI Date',
        //     field: '',
        //     body : getSellerPIDateBody,
        //     style: { minWidth: "110px"}
        // },
        {
            header: 'PI Upoladed Date',
            field: '',
            body : getSellerPIUploadedDateBody,
            style: { minWidth: "90px"}
        },
        {
            header: 'Booking Status',
            field: '',
            body : getBookedStatusBody
        },
        {
            header: 'Booked By',
            field: '',
            body : getBookedByBody,
            style: { minWidth: "150px" }
        },
        {
            header: 'Remarks',
            field: 'remarks',
            body: getRemarksBody,
            // style: { width: "230px"}
        },
        {
            header: 'Amount',
            field: 'remarks',
            style: { minWidth: "90px"},
            body: getAmountBody
        },
        {
            header: 'VP Adjustment',
            field: '',
            style: { minWidth: "120px"},
            body: getVPAdjustmentBody
        },
        {
            header: 'Branch',
            field: '',
            style: { minWidth: "100px"},
            body: branchBody
        },
        {
            header: 'Raise Issue',
            field: '',
            body: raiseIssueBody
        }
    ]

    const actionMenuItems = [
        {
            label: 'Book Adjustment Note',
            icon: '',
            command : () => handleBookAdjustmentNoteClick(),
            permissions: [106]
        },
        {
            label: 'UnBook Adjustment Note',
            icon: '',
            command : () => handleUnBookAdjustmentNoteClick(),
            permissions: [106]
        },
    ];

    const handlePageChange = async (e) => {
        let adjustmentNotesParams = { 
            paginator: true, 
            pageNo: e.page + 1, 
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            ...searchParams
        }
        if (adjustmentNotesParams.searchBy !== "all") {
            adjustmentNotesParams[adjustmentNotesParams.searchBy] = adjustmentNotesParams.searchText.trim()
        }
        dispatch(fetchSellerDebitNotes({...adjustmentNotesParams, adjustmentTypeIds: [3, 9, 10] }))
    }

    const handleCheckboxClick = (row) => {
        const relatedAdjustmentNote = selectedAdjustmentNotes?.find(eachAdjustmentNote => eachAdjustmentNote.adjustmentNoteId === row?.adjustmentNoteId)
        if (relatedAdjustmentNote){
            const relatedAdjustmentNotes = selectedAdjustmentNotes?.filter(eachAdjustmentNote => eachAdjustmentNote?.adjustmentNoteId !== relatedAdjustmentNote?.adjustmentNoteId)
            setSelectedAdjustmentNotes(relatedAdjustmentNotes)
        }else {
            const relatedAdjustmentNotes = [...selectedAdjustmentNotes, row]
            setSelectedAdjustmentNotes(relatedAdjustmentNotes)
        }
    }

    const handleSelectClick = (e) => {
        const relatedAdjustmentNotes = adjustmentNotesData?.map(eachAdjustmentNote => eachAdjustmentNote)
        if (e.checked){
            setSelectedAdjustmentNotes(relatedAdjustmentNotes)
        }else{
            setSelectedAdjustmentNotes([])
        }
    }

    const handleBookAdjustmentNoteClick = async () => {
        if (selectedAdjustmentNotes?.length > 0){
            const relatedDocNos = selectedAdjustmentNotes?.map(eachAdjustmentNote => parseInt(eachAdjustmentNote?.docNo))
            const bookingLogs = selectedAdjustmentNotes?.map(eachAdjustmentNote => {
                return {
                    docNo : eachAdjustmentNote?.docNo,
                    bookedBy : usersData?.userId,
                    bookedAt : new Date()
                }
            })

            const ticketsToBeClosed = selectedAdjustmentNotes.reduce((acc, eachAdjustmentNote) => {
                if (eachAdjustmentNote['relatedTicket.ticketId'] && eachAdjustmentNote['relatedTicket.ticketStatusId'] !== 2){
                    acc.push({
                        ticketId: eachAdjustmentNote['relatedTicket.ticketId'],
                        docNo: eachAdjustmentNote['relatedTicket.docNo'],
                        ticketStatusId: eachAdjustmentNote['relatedTicket.ticketStatusId'],
                        createdBy: eachAdjustmentNote['relatedTicket.createdBy']
                    })
                }
                return acc
            }, [])

            const data = {
                docNos : relatedDocNos,
                bookingStatus : true,
                updatedBy : usersData?.userId,
                bookingLogs : bookingLogs,
                ticketsToBeClosed: ticketsToBeClosed
            }
            setIsPageLoading(true)
            const response = await updateAdjustmentNoteBookingStatus(data)
            if (response?.failure){
                dispatch(raiseToast({severity:'error', summary: 'Booking Status is not Updated', detail:response.data.error, life: 3000}))
            }else {

                dispatch(raiseToast({severity:'success', detail: 'Booking Status Updated Successfully', life: 3000}))
                setSelectedAdjustmentNotes([])
                dispatch(fetchSellerDebitNotes({...paginationParams, ...searchParams, adjustmentTypeId : 3}))
            }
            setIsPageLoading(false)
        }else {
            dispatch(raiseToast({severity:'warn', detail: 'Select Debit Notes', life: 3000}))
        }
    }

    const handleUnBookAdjustmentNoteClick = async () => {
        if (selectedAdjustmentNotes?.length > 0){
            const relatedDocNos = selectedAdjustmentNotes?.map(eachAdjustmentNote => eachAdjustmentNote?.docNo)
            const bookingLogs = selectedAdjustmentNotes?.map(eachAdjustmentNote => {
                return {
                    docNo : eachAdjustmentNote?.docNo,
                    unbookedBy : usersData?.userId,
                    unbookedAt : new Date()
                }
            })
            const data = {
                docNos : relatedDocNos,
                bookingStatus : false,
                updatedBy : usersData?.userId,
                bookingLogs : bookingLogs
            }
            setIsPageLoading(true)
            const response = await updateAdjustmentNoteBookingStatus(data)
            if (response?.failure){
                dispatch(raiseToast({severity:'error', summary: 'Booking Status is not Updated', detail:response.data.error, life: 3000}))
            }else {
                dispatch(raiseToast({severity:'success', detail: 'Booking Status Updated Successfully', life: 3000}))
                setSelectedAdjustmentNotes([])
                dispatch(fetchSellerDebitNotes({...paginationParams, ...searchParams, adjustmentTypeId : 3}))
            }
            setIsPageLoading(false)
        }else {
            dispatch(raiseToast({severity:'warn', detail: 'Select Debit Notes', life: 3000}))
        }
    }

    const handleAdjustmentNoteView = () => {
        setVisibleDocument(false)
        setSelectedAdjNoteDoc('')
    }

    const actionButtons = [
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event),
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
        {
            icon: isSearchPinned ? "pi pi-lock" : "pi pi-lock-open",
            command: () => toggleSearchPin() 
        }
    ]

    let displaySearchBox = isSearchPinned || isHoveringSearchZone || isSearchVisible
    
    console.log("adjustmentNotesData", adjustmentNotesData)
    
    return(
        <div className="piwise-invoce-booking-layout flex flex-column">
            <div
                onMouseEnter={() => {
                    if (!isSearchPinned) {
                        setIsHoveringSearchZone(true)
                        setHasEverHoveredRightEdge(true)
                        dispatch(setIsSearchVisible(true))
                    }
                }}
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    width: '8px',
                    height: '100vh',
                    zIndex: 999
                }}
            />
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">SELLER DEBIT NOTE</h4> 
                <div className="flex flex-row justify-content-end mb-2">
                    <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                    {/* <Button className="h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                    <Button icon="pi pi-filter" className={`h-2rem ml-2 p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                    <ButtonGroup buttons={actionButtons} />
                </div> 
            </div>
            <Loading visible={isPageLoading}/>
            <FileViewModal visible={visibleDocument} document={selectedAdjNoteDoc} handleOnHide={handleAdjustmentNoteView} />
            <div className='flex flex-row'>
                <div className="" style={{ order: "1", width: displaySearchBox && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'"  }}>
                    <div className='p-card mb-0'>
                        <div className="flex-grow-1 petty-cash-table" >
                        <Table 
                            lazy
                            scrollable={"true"} 
                            scrollHeight={"550px"} 
                            onPageChange={(e)=> handlePageChange(e)} 
                            paginator 
                            page={paginationParams.pageNo}
                            totalRecords={paginationParams.totalRecords}
                            tableColumns={tableColumns}
                            rows={paginationParams.recordsPerPage}
                            data={adjustmentNotesData}
                            excessPagesFound= {paginationParams.excessPagesFound}
                            loading={isLoading}
                        />
                        </div>
                    </div>
                </div>

                {displaySearchBox && (
                    <div
                        style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end"
                        onMouseLeave={(e) => {
                            const bounds = e.currentTarget.getBoundingClientRect()
                            const leftExit = e.clientX < bounds.left
                            const topExit = e.clientY < bounds.top
                            const bottomExit = e.clientY > bounds.bottom

                            if (!isSearchPinned && (leftExit || topExit || bottomExit)) {
                                setIsHoveringSearchZone(false)
                                setHasEverHoveredRightEdge(false)
                            }
                        }}

                        onMouseEnter={() => {
                            if (!isSearchPinned) {
                                setIsHoveringSearchZone(true)
                            }
                        }}
                    >
                        <Search />
                    </div>
                )}
                {
                    isSearchVisible && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                            <Search />
                        </Sidebar> 
                    </div>
                }
            </div>
            <Dialog header="RAISE TICKET" visible={isRaiseTicketVisible} style={{ width: '40vw', minHeight: '30vh' }} onHide={() => {setIsRaiseTicketVisible(false)}}>
                <div style={{width: "100%", paddingLeft: "0%", paddingRight: "0%"}}>
                    <RaiseTicketModal selectedRow={selectedRow} setIsLoading={setIsPageLoading} setIsRaiseTicketVisible={setIsRaiseTicketVisible}/>
                </div>
            </Dialog>
            <UpdateVPAdjustmentModal 
                visible={isUpdateVPAdjustmentVisible}
                onHide={() => setIsUpdateVPAdjustmentVisible(false)}
                selectedRow={selectedVPAdjustmentRow}
                paginationParams={paginationParams}
                searchParams={searchParams}
            />
        </div>
    )
}

export default SellerDebitNoteBooking;